import styled from "@emotion/styled";
import { Text, ThemeProps } from "common/components/ui";

export const StyledHeader = styled(Text)<ThemeProps>(
  ({ theme }) => `
    color: ${theme.colors.NEUTRAL[500]};
  `
);
